module.exports = __webpack_public_path__ + "static/media/(LH)-Artesanato-15.7801ad32.jpg";